import React from 'react';
import PropTypes from 'prop-types';

import Text from '../../Text';
import { dataHooks } from '../constants';
import { classes } from './FunnelLabel.st.css';

export const FunnelLabel = ({ value, label, displayValue }) => {
  const numberToPresent = displayValue ? displayValue : value;
  return (
    <div className={classes.root}>
      <Text
        dataHook={dataHooks.labelText}
        size="tiny"
        weight="normal"
        secondary
        ellipsis
        tooltipProps={{ size: 'small' }}
      >
        {label}
      </Text>
      <Text
        dataHook={dataHooks.labelValue}
        size="medium"
        weight="bold"
        ellipsis
      >
        {numberToPresent}
      </Text>
    </div>
  );
};

FunnelLabel.propTypes = {
  /** Label's value */
  value: PropTypes.number,

  /** Label's content */
  label: PropTypes.string.isRequired,

  /** Label's value send by the user */
  displayValue: PropTypes.string,
};
